import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { Container } from "../../Container/Container/Container";
import { SkeletonIndicator } from "../../Indicator/SkeletonIndicator/SkeletonIndicator";
import { SocialBlock } from "../../Block/SocialBlock/SocialBlock";
import styles from "./FoodSocialBlock.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var FoodSocialBlock = function FoodSocialBlock(_ref) {
  var _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    social = _ref.social;
  return /*#__PURE__*/_jsx("div", {
    className: styles.wrapper,
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx("div", {
        className: styles.block,
        children: function () {
          if (loading) {
            return /*#__PURE__*/_jsx("div", {
              className: styles.skeletonWrapper,
              children: /*#__PURE__*/_jsx(SkeletonIndicator, {
                align: "right",
                barWidths: ['100%'],
                size: "large"
              })
            });
          } else if (social) {
            return /*#__PURE__*/_jsx(SocialBlock, _objectSpread({}, social));
          } else {
            return null;
          }
        }()
      })
    })
  });
};